import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { alpha, Box, Container, IconButton, Typography, useTheme } from '@mui/material';
import React, { useId } from 'react';
import { BusinessCategory } from '../../../../MicrospecDynamicUI/Models/Business/BusinessCategory';
import { useMicrospecThemeLanguageContext } from '../../../../MicrospecDynamicUI/Themes';
import UpsertCategory from './UpsertCategory';
import { useNavigate } from 'react-router-dom';

const AddCategory: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { localizationProvider } = useMicrospecThemeLanguageContext();
  const { translate } = localizationProvider;

  const handleSave = (category: BusinessCategory) => {
    // Navigate back to categories list after successful creation
    setTimeout(() => {
      window.location.href = '/manager/categories/manage';
    }, 2000);
  };

  const handleCancel = () => {
    navigate('/manager/categories/manage');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }} key={useId()}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton
          onClick={handleCancel}
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.2),
            },
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: theme.palette.mode === 'dark'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            }}
          >
            {translate('category.addTitle')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {translate('category.createDescription')}
          </Typography>
        </Box>
      </Box>

      <UpsertCategory
        categoryId={undefined}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </Container>
  );
};

export default AddCategory;
